import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './shared/material.module';
// import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { SharedModule } from './shared/shared.module';
import { LoginComponent } from './login';
import { AuthenticationService, BackendService, PagerService } from './_services';
import { HttpClientModule } from '@angular/common/http';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ChartsModule } from "ng2-charts";  
import { AboutComponent } from './about';
import { NotFoundPageComponent } from './notfoundpage';
import { ConfirmDialog } from './shared/dialog.component';
import { LoadingComponent } from  './loading';
import { AuthGuard } from './_guard';
import { NotesComponent } from './notes/notes.component';
import { CompanyComponent } from './company/company.component';
import { ExecutivesComponent } from './executives/executives.component';
import { EnquiriesComponent } from './enquiries/enquiries.component';
import { BuyerenquiriesComponent } from './buyerenquiries/buyerenquiries.component';
import { SellerenquiriesComponent } from './sellerenquiries/sellerenquiries.component';
import { BoughtComponent } from './bought/bought.component';
import { LostComponent } from './lost/lost.component';
import { LostforotherreasonsComponent } from './lostforotherreasons/lostforotherreasons.component';
import { ImportantenqsComponent } from './importantenqs/importantenqs.component';
import { NewenquiriesComponent } from './newenquiries/newenquiries.component';
import { InprogressComponent } from './inprogress/inprogress.component';
import { SubmittedComponent } from './submitted/submitted.component';
import { FuturefollowupsComponent } from './futurefollowups/futurefollowups.component';
import { ClientcallbackComponent } from './clientcallback/clientcallback.component';
import { CarnotavailableComponent } from './carnotavailable/carnotavailable.component';
import { AddeditexecutiveComponent } from './addeditexecutive/addeditexecutive.component';
import { AddeditenquiryComponent } from './addeditenquiry/addeditenquiry.component';
import { EnqresponsesComponent } from './enqresponses/enqresponses.component';
import { FollowupnotrequiredComponent } from './followupnotrequired/followupnotrequired.component';
import { ExecutiveenqviewComponent } from './executiveenqview/executiveenqview.component';
import { NotfollowedupComponent } from './notfollowedup/notfollowedup.component';
import { ExportedtoreassignComponent } from './exportedtoreassign/exportedtoreassign.component';
import { DatePipe, HashLocationStrategy, LocationStrategy, PathLocationStrategy} from '@angular/common';
import { AssignmodalComponent } from './assignmodal/assignmodal.component';
import { CommentmodalComponent } from './commentmodal/commentmodal.component';
import { InreviewComponent } from './inreview/inreview.component';
import { LoginReviewComponent } from './login-review/login-review.component';
import { UpdatereviewComponent } from './updatereview/updatereview.component'

@NgModule({
  declarations: [
    LoginComponent,
    DashboardComponent,
    AboutComponent,
    NotFoundPageComponent,
    ConfirmDialog,
    LoadingComponent,
    AppComponent,
    NotesComponent,
    CompanyComponent,
    ExecutivesComponent,
    EnquiriesComponent,
    BuyerenquiriesComponent,
    SellerenquiriesComponent,
    BoughtComponent,
    LostComponent,
    LostforotherreasonsComponent,
    ImportantenqsComponent,
    NewenquiriesComponent,
    InprogressComponent,
    SubmittedComponent,
    FuturefollowupsComponent,
    ClientcallbackComponent,
    CarnotavailableComponent,
    AddeditexecutiveComponent,
    AddeditenquiryComponent,
    EnqresponsesComponent,
    FollowupnotrequiredComponent,
    ExecutiveenqviewComponent,
    NotfollowedupComponent,
    ExportedtoreassignComponent,
    AssignmodalComponent,
    CommentmodalComponent,
    InreviewComponent,
    LoginReviewComponent,
    UpdatereviewComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    MaterialModule,
    HttpClientModule,
    // ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    ChartsModule,
    AppRoutingModule
  ],
  providers: [
    AuthGuard,
    BackendService,
    AuthenticationService,
    DatePipe,
    {provide:LocationStrategy,useClass:HashLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
